// ENTITIES ##########################################################
import { RequestState } from '@core/interfaces/api.interface';
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)
import { IArchivingStorageMetadataEntityEvents } from '@core/interfaces/entity.interface';

export class StorageMetadataTMO {
	location?: string = undefined;

	type?: StorageTypeEnum = undefined;

	lastModified?: Date = undefined;
}

// MODEL USED IN APPLICATION (with additional properties)
export class StorageMetadata extends StorageMetadataTMO {
	public etag?: string = undefined;

	public ui?: IArchivingStorageMetadataEntityEvents = {
		requestState: RequestState.NOT_ASKED,
		requestError: undefined
	};
}

// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************


// ENUMS #############################################################
// API enums *********************************************************
export enum StorageTypeEnum {
	HOT = 'HOT',
	COLD = 'COLD',
	ARCHIVE = 'ARCHIVE'
}

// UI enums *********************************************************
